module.exports = __webpack_public_path__ + "media/application/images/svgs/archive-2e5ff712c12fddd191d24fe7dc966da4.svg";